<template>
	<div class="forward-message-card" @click="handleClick">
		<div class="card-header">
			<i class="el-icon-chat-line-square"></i>
			<span class="card-title">{{ forwardData.title }}</span>
		</div>
		<div class="card-preview">
			<div
				v-for="(msg, idx) in previewMessages"
				:key="idx"
				class="preview-line">
				<span class="sender-name">{{ msg.senderName }}:</span>
				<span class="content-preview">{{ getContentPreview(msg) }}</span>
			</div>
		</div>
		<div class="card-footer">
			<span class="message-count">共{{ forwardData.messageCount }}条消息</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ForwardMessageCard',
	props: {
		forwardData: {
			type: Object,
			required: true
		}
	},
	computed: {
		previewMessages() {
			// 最多显示3条消息预览
			return this.forwardData.messages.slice(0, 3);
		}
	},
	methods: {
		getContentPreview(msg) {
			if (msg.type === 0) {
				// 文本消息，截取前30个字符
				return msg.content.substring(0, 30) + (msg.content.length > 30 ? '...' : '');
			}
			if (msg.type === 1) return '[图片]';
			if (msg.type === 2) return `[文件: ${msg.fileName}]`;
			if (msg.type === 3) return '[语音]';
			return '[消息]';
		},
		handleClick() {
			this.$emit('open-detail');
		}
	}
}
</script>

<style scoped>
.forward-message-card {
	max-width: 300px;
	min-width: 200px;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	padding: 12px;
	background: #f5f5f5;
	cursor: pointer;
	transition: all 0.2s ease;
	text-align: left;
}

.forward-message-card:hover {
	background: #ebebeb;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 10px;
	padding-bottom: 8px;
	border-bottom: 1px solid #ddd;
}

.card-header i {
	font-size: 18px;
	color: #409eff;
}

.card-title {
	font-weight: bold;
	font-size: 14px;
	color: #333;
}

.card-preview {
	margin-bottom: 8px;
}

.preview-line {
	font-size: 13px;
	color: #666;
	margin-bottom: 4px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	line-height: 1.5;
}

.sender-name {
	font-weight: 500;
	color: #333;
	margin-right: 4px;
}

.content-preview {
	color: #666;
}

.card-footer {
	padding-top: 8px;
	border-top: 1px solid #ddd;
}

.message-count {
	font-size: 12px;
	color: #999;
}
</style>
